<template>
    <!-- Заявки за период vs поставки за период – с источниками, менеджерами и последними комментариями -->
    <div>
        <div class="row mt-3 mb-3 align-items-center">
            <div class="col-auto">
                <div class="green-filter d-flex">
                    <div class="input-group">
                        <input type="date" class="form-control start-input-date" v-model="period_start" :disabled="loading">
                        <input type="date" class="form-control finish-input-date" v-model="period_end" :disabled="loading">
                        <div class="input-group-append" id="button-addon4">
                            <button
                                :class="'btn btn-outline-secondary-period-input active'"
                                type="button"
                                @click="getOrdersVsSupplies()"
                                :disabled="loading"
                            >Обновить</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col"></div>
            <div class="col-auto">
                <b-button @click="isMakeGraphPanel = !isMakeGraphPanel">
                    График
                    <b-icon icon="bar-chart-line" aria-hidden="true" v-if="!isMakeGraphPanel"></b-icon>
                    <b-icon icon="bar-chart-line-fill" aria-hidden="true" v-if="isMakeGraphPanel"></b-icon>
                </b-button>
            </div>
            <div 
                v-if="isPresidentAccount"
                class="col-auto interface_v2"
            >
                <tsoft-select-user
                    id="user-selector"
                    :roles="`sales-manager||sales-head-manager||logistics-manager||logistics-head-manager||logistics-multim-manager||logistics-multim-head-manager||TO-manager||TO-head-manager`"
                    :needNullElement="true"
                    :needAllElement="true"
                    :defaultSelectName="'Все сотрудники'"
                    :selected="selectedUserId"
                    @set="setUserId"
                ></tsoft-select-user>
            </div>
            <div class="col-auto">
                <b-form-select 
                    v-model="selectedGrouping" 
                    :options="optionsGrouping"
                    :disabled="loading"
                ></b-form-select>
            </div>
        </div>

        <GraphAnalytics
            v-if="isMakeGraphPanel"
            :buttons="fields"
            :items="formattedData"
            :whatTab="'orders'"
            class="mb-4"
        />

        <div class="mb-4">
            <b-table 
                :fields="fields"
                :items="formattedData" 
                bordered 
                striped 
                hover
                :busy.sync="loading"
                :sticky-header="computedWindowHeight"
                thead-tr-class="small-head all-th-black"
            >
                <template #cell(date)="data">
                    {{ data.item.date }}
                </template>
                <template #cell(group_1)="data">
                    <template v-if="data.value.length > 0">
                        <span class="cursor-pointer" @click="showByIds(data.value, 'orders', 'Все заявки')">{{ data.value.length }}</span>
                    </template>
                    <template v-else>
                        0
                    </template>
                </template>
                <template #cell(group_2)="data">
                    <template v-if="data.value.length > 0">
                        <span class="cursor-pointer" @click="showByIds(data.value, 'orders', 'Перешли в поставку')">{{ data.value.length }}</span>
                    </template>
                    <template v-else>
                        0
                    </template>
                </template>
                <template #cell(group_3)="data">
                    <template v-if="data.value.length > 0">
                        <span class="cursor-pointer" @click="showByIds(data.value, 'orders', 'Не перешли в поставку')">{{ data.value.length }}</span>
                    </template>
                    <template v-else>
                        0
                    </template>
                </template>
                <template #cell(percentage_group_2)="data">
                    <b>{{ getPercentageGroup2(data.item) }}%</b>
                </template>
                <template #cell(percentage_group_3)="data">
                    <b>{{ getPercentageGroup3(data.item) }}%</b>
                </template>
            </b-table>
        </div>

        <tsoft-order-list
            v-if="orderList && orderList.length > 0"
            :openOrderList="openOrderList"
            :orderList="orderList"
            :label="orderListLabel"
            :ownFields="orderListFields"
            @closeOrderList="closeOrderList"
        >
        </tsoft-order-list>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import OrderList from '@/components/orders/OrderList';
import GraphAnalytics from '@/components/orders/analytic/GraphAnalytics';
import { API_ORDERS_ANALYTICS_ORDERS_VS_SUPPLIES } from '@/constants';

export default {
    components: {
        "tsoft-order-list": OrderList,
        GraphAnalytics,
    },
    data() {
        return {
            loading: false,
            optionsGrouping: [
                { value: 'day', text: 'По дням' },
                { value: 'week', text: 'По неделям' },
                { value: 'month', text: 'По месяцам' },
            ],
            period_start: '',
            period_end: '',
            data: {},
            fields: [
                { key: 'date', label: 'Дата / Период' },
                { key: 'group_1', label: 'Все заявки' },
                { key: 'group_2', label: 'Перешли в поставку', variant: 'success' },
                { key: 'percentage_group_2', label: 'Перешли в поставку в процентах', variant: 'success' },
                { key: 'group_3', label: 'Не перешли в поставку', variant: 'warning' },,
                { key: 'percentage_group_3', label: 'Не перешли в поставку в процентах', variant: 'warning' },
            ],
            orderList: [],
            openOrderList: false,
            orderListLabel: '',
            orderListFields: [
                {
                    key: 'id',
                    label: 'ID',
                    stickyColumn: true,
                    sortable: true,
                    sortDirection: 'desc',
                    visible: true,
                    'tdAttr': {
                        'data-t': 'n',
                    }
                },
                {
                    key: 'company.name',
                    label: 'Клиент',
                    stickyColumn: false,
                    sortable: true,
                    sortDirection: 'desc',
                    visible: true
                },
                {
                    key: 'creator.name',
                    label: 'Менеджер поставки',
                    sortable: true,
                    sortDirection: 'desc',
                    visible: true
                },
                {
                    key: 'sales_manager',
                    label: 'Sales менеджер',
                    sortable: true,
                    sortDirection: 'desc',
                    visible: true
                },
                {
                    label: "Последний комментарий",
                    sortable: false,
                    key: "last_comment",
                },
                {
                    key: 'source.name',
                    label: 'Источник поставки',
                    sortable: true,
                    sortDirection: 'desc',
                    visible: true
                },
                {
                    key: 'selected_services',
                    label: 'Вид услуги',
                    sortable: true,
                    sortDirection: 'desc',
                    visible: true
                },
                {
                    key: 'receive_datetime',
                    label: 'Дата получения заявки',
                    sortable: true,
                    sortDirection: 'desc',
                    visible: true
                },
                {
                    key: 'status.name',
                    label: 'Статус',
                    sortable: true,
                    sortDirection: 'desc',
                    visible: true
                },
                {
                    key: 'close_reason.name',
                    label: 'Причина закрытия',
                    sortable: true,
                    sortDirection: 'desc',
                    visible: true
                },
                {
                    key: 'close_comment',
                    label: 'Комментарий при закрытии',
                    sortable: true,
                    sortDirection: 'desc',
                    visible: true
                },
                {
                    key: 'updated_at',
                    label: 'Последние изменения в карточке',
                    sortable: true,
                    sortDirection: 'desc',
                    visible: true
                }
            ],
            selectedGrouping: 'month',
            selectedUserId: '',
            computedWindowHeight: '',
            isMakeGraphPanel: false,
        };
    },
    computed: {
        ...mapGetters("auth", ["currentUser"]),

        isSalesManagerAccount() {
            return this.currentUser.role.includes('sales-manager');
        },

        isPresidentAccount() {
            return this.currentUser.role.includes('president') || this.currentUser.role.includes('administrator');
        },

        groupedData() {
            let grouped = {};
            for (const date in this.data) {
                let groupKey;
                if (this.selectedGrouping === 'week') {
                    groupKey = this.$moment(date).startOf('isoWeek').format('YYYY-MM-DD');
                } else if (this.selectedGrouping === 'month') {
                    groupKey = this.$moment(date).startOf('month').format('YYYY-MM-DD');
                } else {
                    groupKey = date; // daily grouping
                }

                if (!grouped[groupKey]) {
                    grouped[groupKey] = this.initializeGroupStructure();
                }

                for (const groupName in this.data[date]) {
                    const orders = this.data[date][groupName].order_ids;
                    grouped[groupKey][groupName].order_ids.push(...orders);
                }
            }
            return grouped;
        },
        formattedData() {
            this.$moment.locale('ru');
            const formatted = [];
            for (const date in this.groupedData) {
                const item = { date: this.formatDate(date, this.selectedGrouping), };
                const groups = this.groupedData[date];
                for (const groupName in groups) {
                    item[groupName] = groups[groupName].order_ids;
                }
                formatted.push(item);
            }
            return formatted;
        },
    },
    mounted() {
        this.handlerHeightWindow();
        this.getOrdersVsSupplies();
    },
    created() {
        window.addEventListener('resize', this.handlerHeightWindow);
    },
    destroyed() {
        window.removeEventListener('resize', this.handlerHeightWindow);
    },
    methods: {
        getOrdersVsSupplies() {
            this.loading = true;

            if (this.isSalesManagerAccount) {
                this.selectedUserId = this.currentUser.id;
            }

            const request = {
                period_start: this.period_start,
                period_end: this.period_end,
                user_id: this.selectedUserId,
            };
            axios
                .post(`${API_ORDERS_ANALYTICS_ORDERS_VS_SUPPLIES}`, request)
                .then(({ data }) => {
                    this.data = data.data;
                    this.period_start = data.params.period_start;
                    this.period_end = data.params.period_end;
                    // Не перезаписываем selectedUserId из ответа сервера, чтобы не сбить выбор пользователя
                    // this.selectedUserId = data.params.user_id;

                    this.loading = false;
            });
        },
        showByIds(ids, type = 'orders', label = 'Список', order_to_manager = null) {
            if (type == 'orders') {
                this.orderList = ids;
                this.orderListLabel = label;
                this.openOrderList = true;
            }
        },
        closeOrderList() {
            this.orderList = [];
            this.openOrderList = false;
        },
        initializeGroupStructure() {
            return {
                'group_1': { order_ids: [] },
                'group_2': { order_ids: [] },
                'group_3': { order_ids: [] },
            };
        },
        formatDate(date, grouping) {
            if (grouping === 'day') {
                return this.$moment(date).format('DD.MM.YYYY');
            } else if (grouping === 'week') {
                const weekStart = this.$moment(date).startOf('isoWeek');
                const weekEnd = this.$moment(date).endOf('isoWeek');
                return `${weekStart.format('DD.MM')} - ${weekEnd.format('DD.MM.YYYY')} (${weekStart.format('W')}-я неделя)`;
            } else if (grouping === 'month') {
                return this.$moment(date).format('MMMM YYYY');
            }
            return date;
        },
        handlerHeightWindow() {
            let deleteHeight = 230
            this.computedWindowHeight = `${window.top.innerHeight - deleteHeight}px`
        },
        getPercentageGroup2(row) {
            let group_1 = row['group_1'].length;
            let group_2 = row['group_2'].length;

            if (group_1 === 0 || group_2 === 0) { return 0; }

            return Math.round(group_2 / group_1 * 100);
        },
        getPercentageGroup3(row) {
            let group_1 = row['group_1'].length;
            let group_3 = row['group_3'].length;

            if (group_1 === 0 || group_3 === 0) { return 0; }

            return Math.round(group_3 / group_1 * 100);
        },
        setUserId(id) {
          this.selectedUserId = id;

          this.getOrdersVsSupplies();
        }
    },
};
</script>

<style scoped>
.custom-select {
    height: 35px !important;
    line-height: 35px;
    padding: 0 30px 0 20px;
}
</style>